import React from 'react'
import SummaryList from './SummaryList'
import styles from './styles.module.css'


const Summary = () => {

    return (
        <div className={styles.summaryContainer}>
            <div className={`${styles.callSummary}`}>
                <h4>CALL SUMMARY</h4>
                <div className={`bg-white ${styles.summaryMetrics} container`}>
                    <SummaryList type="call" />
                </div>
            </div>
            <div className={`${styles.chatSummary}`}>
                <h4>CHAT SUMMARY</h4>
                <div className={`bg-white ${styles.summaryMetrics} container`}>
                    <SummaryList type="chat" />
                </div>
            </div>
        </div>
    )
}

export default Summary
